import script from "./PointsOverviewModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PointsOverviewModal.vue?vue&type=script&setup=true&lang=js"

import "./PointsOverviewModal.vue?vue&type=style&index=0&id=1d2b7ef6&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d2b7ef6"]])

export default __exports__